// Func = limiting Scope for this file
var lastScrollTop = 0;

var BookLanding = document.getElementById('BookLanding');

(function(){

	//is explorer
	function msieversion() {

		var ua = window.navigator.userAgent;
		var msie = ua.indexOf("MSIE ");
		if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
		{
			const image_fit = document.getElementsByTagName('figure');
			for(let i = 0; i < image_fit.length; i++ ){
				const this_image = image_fit[i].getElementsByTagName('img')[0];
				const image_data = this_image.dataset.srcset;
				const image_src = this_image.getAttribute('src');
				image_fit[i].classList.add('ie-bg');
				if(image_data){
					image_fit[i].style.backgroundImage = 'url("'+image_data+'")';
				}else{
					image_fit[i].style.backgroundImage = 'url("'+image_src+'")';
				}
			}
		}
		else
		{
			//console.log('other browser');
		}
		return false;
	}

	msieversion();

	$(".form-module-wrapper form").addClass('animate-fade top');
	$(".text-modules-wrapper .text-modules").addClass('animate-fade top');

	$(".form-module-wrapper, .text-modules-wrapper, .global-sitemap").append('<div class="container lines animate-fade"></div>');

	$(document).ready(function () {
		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});

		$( "#CheckOut" ).datepicker({
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		$(".slick-tabs").slick({
			dots: false,
			infinite: true,
			arrows: true,
			slidesToShow: 5,
			prevArrow: ".arrows__prev",
			nextArrow: ".arrows__next",
			responsive: [
				{
					breakpoint: 1200,
					settings: {
					slidesToShow: 1,
					arrows: true,
					fade: true,
					},
				},
			],
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

		let MenuBtn = document.getElementById('menu-btn');
		let Navigation = document.getElementById('navigation');
		let CloseMenu = document.getElementById('close_menu');
		let Body = document.getElementsByTagName('body')[0];

		let BookNow = document.getElementById('book-now');
		let BookBox = document.getElementById('bookBox');
		let CloseBook = document.getElementById('close_booking');

		if(MenuBtn){
			$(MenuBtn).click(function(event) {
				event.preventDefault();
				Navigation.classList.add('open');
				Body.classList.add('scroll-no');
			});
			$(CloseMenu).click(function(event) {
				event.preventDefault();
				Navigation.classList.remove('open');
				Body.classList.remove('scroll-no');
			});
		}

		if(BookBox){
			$(BookNow).click(function(event) {
				event.preventDefault();
				BookBox.classList.add('open');
				Body.classList.add('scroll-no');
			});
			$(CloseBook).click(function(event) {
				event.preventDefault();
				BookBox.classList.remove('open');
				Body.classList.remove('scroll-no');
			});
		}

		//Pop in close function
		// Pop-in add x
		if($('#content-popin').length>0){
			$('#content-popin .box-content-popin').append('<div class="close-popin"></div>');
			$('#content-popin .close-popin').click(function(){
			$('.box-arrow-popin .arrow').addClass("open");
			$('.box-content-popin').removeClass("open");
			TogglePopIn();	
			});
		}
		
	});

	let screenHeight = $(window).height();
	$('#home .top-img figure, #home .top-img video').css("height", screenHeight);

	$(window).resize(function(){
		screenHeight = $(window).height();
		$('#home .top-img figure, #home .top-img video').css("height", screenHeight);
	});

	const video = document.querySelector("#video__topContent")
	// pause or play the video
	const play = (e) => {
		// Condition when to play a video
		if(video.paused){
			document.querySelector(".fa-play").style.display = "none"
			document.querySelector(".fa-pause").style.display = "block"
			video.play()
		}
		else{
			document.querySelector(".fa-play").style.display = "block"
			document.querySelector(".fa-pause").style.display = "none"
			video.pause()
		}
	}


	window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}

	if (document.getElementById('landing-page') || document.getElementById('resorts')) {
		let topContentSize = document.querySelector(".top-img") ? document.querySelector(".top-img").getBoundingClientRect().height : 0;
		if (st < 720 + topContentSize) {
			BookLanding.classList.add('landing-open');
		} else {
			BookLanding.classList.remove('landing-open');
		}
	}

	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}